import { ref, shallowRef } from "vue";
import {apiFetch} from "@/libs/wordpress.facade";

type CountryState = Record<string, string>;
type CountryStates = Record<string, CountryState>;

const countries = shallowRef<Record<string, string>>({});
const shippingCountries = shallowRef<Record<string, string>>({});
const countryLocale = shallowRef<Record<string, {
	postcode?: { label?: string; hidden?: boolean; required?: boolean;};
	state?: { label?: string; hidden?: boolean; required?: boolean; }
}>>({});
const countryStates = shallowRef<CountryStates>({});
const countriesLoading = ref(false);
async function loadCountries(){
	if(countries.value.length) return countries.value;
	countriesLoading.value = true;
	try{
		const res = (await apiFetch({
			path: '/itlp/v1/locale/countries?_locale=site',
			method: 'GET',
			parse: false
		})) as Response;

		const response = await res.json();
		countries.value = response.countries;
		shippingCountries.value = response.shipping_countries;
		countryLocale.value = response.country_locale;
		if(response.country_states){
			const _countryStates:CountryStates = {};
			for (const [key, val] of Object.entries(response.country_states)) {
				if(typeof(val) !== 'object') continue;
				_countryStates[key] = val as Record<string, string>;
			}
			countryStates.value = _countryStates;
		}
	}catch(e){
		console.error(e);
	}
	countriesLoading.value = false;
}

export default function (){
	return {
		countries,
		shippingCountries,
		countryLocale,
		countryStates,
		countriesLoading,
		loadCountries
	};
}